import { observable, makeObservable } from 'mobx';
import { DataState } from 'typings/enums';

export class AppState {
    @observable dataState: DataState;

    constructor() {
        makeObservable(this);
        this.dataState = DataState.Idle;
    }

    get currentDataState(): DataState {
        return this.dataState;
    }

    transitionDataState = (newState: DataState): void => {
        this.dataState = newState;
    }
}